import { render, staticRenderFns } from "./SectionHeaderV1.vue?vue&type=template&id=dedfcf34&"
import script from "./SectionHeaderV1.vue?vue&type=script&lang=js&"
export * from "./SectionHeaderV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports